///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { Link } from "react-router-dom";

import Notification from "./Notification";
import closeNotificationFlyoutWindow from "../../helpers/closeNotificationFlyoutWindow";
import messages from "../../helpers/messages";

export const NotificationList = ({ notifications, isFlyout }) => {
  const style = isFlyout
    ? { maxHeight: window.screen.height - 452 }
    : undefined;

  return (
    <>
      <div
        className={`${
          isFlyout && notifications.length
            ? "overflow-y--scroll scroll mr-2 ml-6 mt-8"
            : ""
        }`}
        style={style}
      >
        {notifications &&
          notifications.map((notification, index) => (
            <Notification
              key={`notification-${index}`}
              notification={notification}
              isFlyout={isFlyout}
            />
          ))}
      </div>
      {isFlyout && (
        <div
          className="text-center"
          style={{ borderTop: "1px solid #e4e4e4", padding: "18px 0px" }}
        >
          <Link
            to="/notifications"
            className="text-blue decoration-none"
            data-testid="all-notifications"
            onClick={closeNotificationFlyoutWindow}
          >
            {messages.seeAllNotifications.defaultMessage}
          </Link>
        </div>
      )}
    </>
  );
};

export default NotificationList;
